import { jsxs as a, jsx as o } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as s } from "../../../context/theme/hooks.js";
import "../../layout/Stack/Stack.js";
import r from "../../layout/Box/Box.js";
import "react";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import c from "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
import { directionToStylesMap as d } from "./consts.js";
function M({
  direction: e = "horizontal",
  emphasis: l = "xLow",
  includeOr: p = !1
}) {
  const m = s(), n = l === "xLow" ? m["neutral-xLow-content"] : m["neutral-low-content"], { width: t, height: i } = d[e];
  return /* @__PURE__ */ a(
    r,
    {
      width: t,
      height: i,
      display: "flex",
      flexDirection: e === "horizontal" ? "row" : "column",
      alignItems: "center",
      children: [
        /* @__PURE__ */ o(r, { width: t, height: i, backgroundColor: n }),
        p && /* @__PURE__ */ o(r, { padding: "large", children: /* @__PURE__ */ o(c, { size: "small", emphasis: "medium", children: "OR" }) }),
        /* @__PURE__ */ o(r, { width: t, height: i, backgroundColor: n })
      ]
    }
  );
}
export {
  M as default
};
